// desktop screen images
import HouseDesktop from "../../../images/Banner/Home desktop.jpg";
import EventDesktop from "../../../images/Banner/Event desktop.jpg";
import WorkspaceDesktop from "../../../images/Banner/Office desktop.jpg";
import RVsDesktop from "../../../images/Banner/RVs desktop.jpg";
import BoatsDesktop from "../../../images/Banner/Boat desktop.jpg";
import ElectronicsDesktop from "../../../images/Banner/Electronics desktop.jpg";
import PowerToolsDesktop from "../../../images/Banner/Power tools desktop.jpg";
import FilmEquipmentDesktop from "../../../images/Banner/Film equipment desktop.jpg";
import EventEquipmentDesktop from "../../../images/Banner/Event Equipment desktop.jpg";
import BikesDesktop from "../../../images/Banner/Bikes desktop.jpg";
import ParkingDesktop from "../../../images/Banner/Parking desktop.jpg";
import WorkDesktop from "../../../images/Banner/Cars desktop(1).jpg";

// mobile screen images
import HouseMobile from "../../../images/Banner/Houses mobile.jpg";
import EventsMobile from "../../../images/Banner/Event mobile.jpg";
import WorkspaceMobile from "../../../images/Banner/Office mobile.jpg";
import RVsMobile from "../../../images/Banner/RVs mobile.jpg";
import BoatsMobile from "../../../images/Banner/Boat mobiles.jpg";
import ElectronicsMobile from "../../../images/Banner/Electronics mobile.jpg";
import PowerToolsMobile from "../../../images/Banner/power tools square mobile.jpg";
import FilmEquipmentMobile from "../../../images/Banner/Film equipment mobile.jpg";
import EventEquipmentMobile from "../../../images/Banner/event Equipment square mobile.jpg";
import BikesMobile from "../../../images/Banner/Bikes mobile.jpg";
import ParkingMobile from "../../../images/Banner/Parking 1 mobile.jpg";
import WorkVehicles from "../../../images/Banner/Vehicles mobile.jpg";

export const BannerData = [
  {
    imgDesktop: HouseDesktop,
    imgMobile: HouseMobile,
    DesktopTitle: "Vacation Homes",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "short and long term rental,",
    DesktopSubTitle3: "and much more!",
    // mobile silder text
    MobileTitle: "Vacation Homes",
    MobileColorText: "We Share,",
    MobileSubTitle: "short and long term ",
    MobileSubTitle3: "rental and much more!",
    dataHome: "Homes",
  },

  {
    imgDesktop: EventDesktop,
    imgMobile: EventsMobile,
    DesktopTitle: "Events Space & Equipment",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Wedding Halls, Conferences Rooms,",
    DesktopSubTitle3: "Receptions, and equipment",
    // mobile silder text
    MobileTitle: "Events Space",
    MobileColorText: "We Share,",
    MobileSubTitle: "Wedding Halls,",
    MobileSubTitle3: "Receptions and equipment",
    dataHome: "Events",
  },
  {
    imgDesktop: WorkspaceDesktop,
    imgMobile: WorkspaceMobile,
    DesktopTitle: "Workspace",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Offices and Conference Rooms",
    // mobile silder text
    MobileTitle: "Workspace",
    MobileColorText: "We Share,",
    MobileSubTitle: "Offices and",
    MobileSubTitle3: "Conference Rooms",
  },
  {
    imgDesktop: RVsDesktop,
    imgMobile: RVsMobile,
    DesktopTitle: "RVs",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "RVs, Sport & Camping equipment",
    // mobile silder text
    MobileTitle: "RVs",
    MobileColorText: "We Share,",
    MobileSubTitle: "RVs, Sport",
    MobileSubTitle3: "& Camping equipment",
  },
  {
    imgDesktop: BoatsDesktop,
    imgMobile: BoatsMobile,
    DesktopTitle: "Boats",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Yachts, Speedboats & Sailboats",
    // mobile silder text
    MobileTitle: "Boats",
    MobileColorText: "We Share,",
    MobileSubTitle: "Yachts, Speedboats",
    MobileSubTitle3: "& Sailboats",
  },
  {
    imgDesktop: ElectronicsDesktop,
    imgMobile: ElectronicsMobile,
    DesktopTitle: "Electronics",
    DesktopColorText: "Don’t Buy! We Share!, ",
    DesktopSubTitle2: "Drones, Projectors, Music Inst. DJ equip. etc.",
    // mobile silder text
    MobileTitle: "Electronics",
    DesktopSubTitle3: "Save money, do more, get more!",
    MobileColorText: "Don’t Buy! We Share!",
    MobileSubTitle2: "Drones, Projectors,",
    MobileEleSubTitle2: " Music Inst. DJ equip. etc.",
    MobileSubTitle3: "Save money, do more, get more!",
    Desktopdta: "down",
    Mobilepdta: "down",
    br: true,
  },
  {
    imgDesktop: PowerToolsDesktop,
    imgMobile: PowerToolsMobile,
    DesktopTitle: "Power Tools",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Work tools for Carpentry, Construction, Landscaping, etc",
    // mobile silder text
    MobileTitle: "Power Tools",
    // MobileColorText: "We Share,",
    MobileSubTitle: "Work tools for Carpentry, Construction, Landscaping, etc",
    // MobileSubTitle3: "Work Vehicles",
  },
  {
    imgDesktop: FilmEquipmentDesktop,
    imgMobile: FilmEquipmentMobile,
    DesktopTitle: "Film Equipment",
    DesktopColorText: "Don’t Buy! We Share,",
    DesktopSubTitle3: "Save money, do more, get more!",
    // mobile silder text
    MobileTitle: "Film Equipment",
    MobileColorText: "Don’t Buy! We Share!",
    MobileSubTitle3: "Save money, do more, get more!",
    Desktopdta: "down",
    br: true,
  },
  {
    imgDesktop: EventEquipmentDesktop,
    imgMobile: EventEquipmentMobile,
    DesktopTitle: "Event Equipment",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Sound, Lighting, Video and Music Instruments",
    // mobile silder text
    MobileTitle: "Event Equipment",
    // MobileColorText: "We Share,",
    MobileSubTitle: "Sound, Lighting, Video and Music Instruments",
    // MobileSubTitle3: "Work Vehicles",
  },
  {
    imgDesktop: BikesDesktop,
    imgMobile: BikesMobile,
    DesktopTitle: "Bikes",
    DesktopSubTitle22: "Scooters, mountain bikes, road bikes",
    DesktopColorText: "Don't Buy! We Share,",
    DesktopSubTitle3: "Save money, do more, get more!",
    // mobile silder text
    MobileTitle: "Bikes",
    MobileSubTitle22: "Scooters, mountain bikes",
    MobileSubTitle23: "&road bikes",
    MobileColorText: "Don't Buy! We Share!",
    MobileSubTitle3: "Save money, do more, get more!",
    Desktopdta: "down",
    Mobilepdta: "down",
  },
  {
    imgDesktop: ParkingDesktop,
    imgMobile: ParkingMobile,
    DesktopTitle: "Parking",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Garages, Storage, Warehouses",
    // mobile silder text
    MobileTitle: "Parking",
    MobileColorText: "We Share,",
    MobileSubTitle: "in-door & out-door",
    MobileSubTitle3: "Garages, Storage, Warehouses",
  },
  {
    imgDesktop: WorkDesktop,
    imgMobile: WorkVehicles,
    DesktopTitle: "Vehicles",
    DesktopColorText: "We Share,",
    DesktopSubTitle: "Cars, Vans And Work Vehicles",
    // mobile silder text
    MobileTitle: "Vehicles",
    MobileColorText: "We Share,",
    MobileSubTitle: "Cars, Vans And",
    MobileSubTitle3: "Work Vehicles",
  },
];
